import { render, staticRenderFns } from "./Collaborator.vue?vue&type=template&id=ace77bc4&scoped=true&"
import script from "./Collaborator.vue?vue&type=script&lang=js&"
export * from "./Collaborator.vue?vue&type=script&lang=js&"
import style0 from "./Collaborator.vue?vue&type=style&index=0&id=ace77bc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace77bc4",
  null
  
)

export default component.exports